import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await register(form.name, form.email, form.password);
    setLoading(false);
    if (res.ok) {
      setDone(true);
      toast.success("Access request submitted");
    } else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg)] p-8">
      <div className="w-full max-w-md">
        <div className="text-[11px] uppercase tracking-widest text-[var(--text-2)] mb-2">Request access</div>
        <h2 className="font-serif text-3xl mb-8">Join Event Team.</h2>

        {done ? (
          <div className="card-sharp p-6" data-testid="register-success">
            <div className="font-serif text-lg mb-2">Request submitted</div>
            <p className="text-sm text-[var(--text-2)] mb-4">
              Your account is pending administrator approval. You will be able to sign in once
              an admin activates your access.
            </p>
            <Link to="/login">
              <Button className="rounded-none bg-[var(--primary)] hover:bg-[var(--primary)]/90 text-white">
                Return to sign in
              </Button>
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            <div>
              <Label className="text-xs uppercase tracking-widest">Full name</Label>
              <Input
                data-testid="register-name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
                className="rounded-none border-[var(--border-1)]"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest">Email</Label>
              <Input
                data-testid="register-email"
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                className="rounded-none border-[var(--border-1)]"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest">Password</Label>
              <Input
                data-testid="register-password"
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
                minLength={6}
                className="rounded-none border-[var(--border-1)]"
              />
            </div>
            {error && (
              <div className="text-sm text-[var(--accent)] border border-[var(--accent)] px-3 py-2" data-testid="register-error">
                {error}
              </div>
            )}
            <Button
              type="submit"
              disabled={loading}
              data-testid="register-submit"
              className="w-full rounded-none bg-[var(--primary)] hover:bg-[var(--primary)]/90 text-white h-11"
            >
              {loading ? "Submitting…" : "Request access →"}
            </Button>
            <div className="text-sm text-[var(--text-2)]">
              Already approved?{" "}
              <Link to="/login" className="text-[var(--primary)] underline underline-offset-4" data-testid="link-login">
                Sign in
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
